import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.baseContainerUrl + '/api/v1/'

export const ContainerRunCmdToObject = (cmd, node = null) => {
  let reqData = {
    cmd: cmd
  }
  if (node) {
    reqData.node = node
  }
  return axios.request({
    url: baseUrl + 'cmd_to_object/',
    data: reqData,
    method: 'post'
  })
}

export const ContainerRunObjectToCmd = (data) => {
  return axios.request({
    url: baseUrl + 'object_to_cmd/',
    data: data,
    method: 'post'
  })
}
